import React, { Component } from "react";

class ServiceFeedback extends Component {
  state = {};
  render() {
    return <h1>Service Feedback</h1>;
  }
}

export default ServiceFeedback;



// WEBPACK FOOTER //
// ./src/views/BookedServices/ServiceFeedback/ServiceFeedback.jsx